import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

/**
 * Questo data service deve rimanere svincolato dall'implementazione tecnica dei sidenav.
 * Non deve contenere riferimenti a material.
 */
@Injectable()
export class CanvasLayoutDataService {

    viewportHeight: number;
    viewportWidth: number;
    headerHeight: number;
    pageBodyWidth: number;
    pageBodyHeight: number;
    bgUrl: string;
    bgColor: string;

    public onResize() {
        this.viewportHeight = window.innerHeight;
        this.viewportWidth = window.innerWidth;

        this._width = window.innerWidth;
        this.widthObs.next(this._width)
        this._calculateWorkingWidth()
        if (this.isLesserThanL())
            this.sidenav1Mode = 'over'
        else
            this.sidenav1Mode = 'side'
    }

    private _width;
    get width() {
        return this._width
    }
    widthObs = new BehaviorSubject<number>(this.width);

    // Viene calcolato ad ogni settaggio di width da parte di CanvasLayoutComponent (ogni volta che viene rilevato un cambio di dimensione del canvas)
    // Il calcolo viene effettuato sottraendo la larghezza del sidenav1 se sidenav1Mode=='side' e isSidenav1Open==true
    private _workingWidth: number
    get workingWidth() {
        return this._workingWidth
    }
    workingWidthObs = new BehaviorSubject<number>(this.workingWidth);

    //Stato di apertura della sidenav principale
    public isSidenav1Open: boolean;

    //Stato di apertura della sidenav secondaria
    public isSidenav2Open: boolean;

    /**
     * Modalità di apertura del pannello laterale principale
     * - 'over' -> apre in overlay rispetto al canvas
     * - 'side' -> apre sullo stesso piano rispetto al canvas, facendo stringere il canvas stesso
     * - 'push' -> apre sullo stesso piano rispetto al canvas, spingendo il canvas stesso lateralmente
     * 
     * https://stackblitz.com/angular/jbpmnlrrqqp?file=app%2Fsidenav-mode-example.ts
     */
    public sidenav1Mode: 'over' | 'side' | 'push';

    /**
     * Modalità di apertura del pannello laterale secondario
     * Viene forzato a 'side'
     */
    public sidenav2Mode: 'over' | 'side' | 'push' = 'side';

    constructor() {
        this.sidenav1Mode = 'side';
        this.isSidenav1Open = false;
    }

    public openSidenav1() {
        this.isSidenav1Open = true;
        this._calculateWorkingWidth();
    }

    public closeSidenav1() {
        this.isSidenav1Open = false;
        this._calculateWorkingWidth();
    }

    public toggleSidenav1() {
        this.isSidenav1Open = !this.isSidenav1Open;
        this._calculateWorkingWidth();
    }

    public openSidenav2() {
        this.isSidenav2Open = true;
        this._calculateWorkingWidth();
    }

    public closeSidenav2() {
        this.isSidenav2Open = false;
        this._calculateWorkingWidth();
    }

    public toggleSidenav2() {
        this.isSidenav2Open = !this.isSidenav2Open;
        this._calculateWorkingWidth();
    }

    public isXxxs() {
        return (window.innerWidth < 420);
    }
    public isXxs() {
        return (window.innerWidth >= 420 && window.innerWidth < 768);
    }
    public isXs() {
        return (window.innerWidth >= 768 && window.innerWidth < 960);
    }
    public isS() {
        return (window.innerWidth >= 960 && window.innerWidth < 1024);
    }
    public isM() {
        return (window.innerWidth >= 1024 && window.innerWidth < 1280);
    }
    public isL() {
        return (window.innerWidth >= 1280 && window.innerWidth < 1680);
    }
    public isXl() {
        return (window.innerWidth >= 1680 && window.innerWidth < 1920);
    }
    public isXxl() {
        return (window.innerWidth >= 1920);
    }
    public isGreaterThanXxxs() {
        return !this.isXxxs();
    }
    public isGreaterThanXxs() {
        return !this.isXxxs() && !this.isXxs();
    }
    public isLesserThanXs() {
        return !this.isXxl() && !this.isXl() && !this.isL() && !this.isM() && !this.isS() && !this.isXs();
    }
    public isGreaterThanXs() {
        return !this.isXxs() && !this.isXs();
    }
    public isLesserThanS() {
        return !this.isXxl() && !this.isXl() && !this.isL() && !this.isM() && !this.isS();
    }
    public isGreaterThanS() {
        return !this.isXxs() && !this.isXs() && !this.isS();
    }
    public isLesserThanM() {
        return !this.isXxl() && !this.isXl() && !this.isL() && !this.isM();
    }
    public isGreaterThanM() {
        return !this.isXxs() && !this.isXs() && !this.isS() && !this.isM();
    }
    public isLesserThanL() {
        return !this.isXxl() && !this.isXl() && !this.isL();
    }
    public isGreaterThanL() {
        return !this.isXxs() && !this.isXs() && !this.isS() && !this.isM() && !this.isL();
    }
    public isLesserThanXl() {
        return !this.isXxl() && !this.isXl();
    }
    public isGreaterThanXL() {
        return !this.isXxs() && !this.isXs() && !this.isS() && !this.isM() && !this.isL() && !this.isXl();
    }
    public isLesserThanXxl() {
        return !this.isXxl();
    }

    private _calculateWorkingWidth = () => {
        const sideBar1Width = (this.isSidenav1Open && this.sidenav1Mode == 'side') ? 280 : 0;
        const sideBar2Width = (this.isSidenav2Open) ? 280 : 0;

        this._workingWidth = this._width - sideBar1Width - sideBar2Width;
        this.workingWidthObs.next(this.workingWidth)
    }
}